/**
 * Joins class names, dropping anything falsy.
 *
 * Its own module so `form.tsx` and `index.tsx` can both use it without either
 * importing the other — they are siblings, not layers.
 */
export const cx = (...parts: (string | false | null | undefined)[]) => parts.filter(Boolean).join(' ');
